/** Public-search result display modes. */
export const RESULT_DISPLAY_TYPE = {
  LIST: 'list',
  GALLERY: 'gallery',
} as const;

export type ResultDisplayType =
  (typeof RESULT_DISPLAY_TYPE)[keyof typeof RESULT_DISPLAY_TYPE];
